import { styled } from "../../styles";

/**
 * One line of text inside a dark antd tooltip.
 *
 * Shared so every tooltip in the portal reads the same. Pair it with the
 * house tooltip chrome:
 *
 * ```tsx
 * <Tooltip
 *   title={<TooltipLine emphasis>…</TooltipLine>}
 *   arrow={false}
 *   color="#4B4B4B"
 *   mouseLeaveDelay={0}
 *   styles={{ body: { padding: "16px 20px", borderRadius: "4px !important" } }}
 * >
 * ```
 */
export const TooltipLine = styled("div", {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "12px",
  lineHeight: "18px",
  color: "$white",
  fontWeight: 400,

  variants: {
    emphasis: {
      true: {
        fontSize: "13px",
        fontWeight: 400,
        marginBottom: "2px",
      },
    },
    strong: {
      true: {
        fontWeight: 600,
      },
    },
  },
});
